import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    // If you change the language here, then it changes in the editor itself
    current: 'en' // en | es | fr | pl | ru
  }
});
